import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { StatusTrackingDto } from '../../../shared/modules/status-tracking/dtos/status-tracking.dto';
import { VehicleFeatureItemDto } from '../../../shared/modules/vehicle-feature-items/dtos/vehicle-feature-item.dto';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleCategoryRecordDto } from '../../vehicle-categories';
import { VehicleMakeSearchDto } from '../../../shared/modules/vehicle-makes';
import { VehicleModelSearchDto } from '../../../shared/modules/vehicle-models';
import { VehicleAllocationEnum } from '../enums/vehicle-allocation.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehicleStatusEnum } from '../enums/vehicle-status.enum';
import { VehicleTransmissionTypeEnum } from '../enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

import { VehicleAvailabilityDto } from './vehicle-availability.dto';

/**
 * Vehicle DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleSearchDto extends BaseSearchDto {
  uuid!: string;
  vin!: string;
  engineNumber?: string | null;
  licensePlate?: string | null;
  lastOdometerFull?: string | null;
  status!: VehicleStatusEnum;
  make?: VehicleMakeSearchDto | null;
  model?: VehicleModelSearchDto | null;
  makeFull?: string | null;
  seats?: number | null;
  seriesTrimFull?: string | null;
  type!: VehicleTypeEnum;
  fuelType?: VehicleFuelTypeEnum | null;
  transmissionType?: VehicleTransmissionTypeEnum | null;
  exteriorColorName?: string | null;
  interiorColorName?: string | null;
  vehicleCategory?: VehicleCategoryRecordDto | null;
  supplierId?: number | null;
  supplier?: SupplierSearchDto | null;
  locationCode?: string | null;
  allocation?: VehicleAllocationEnum | null;
  statusTracking?: StatusTrackingDto<VehicleStatusEnum>[] | null;
  featureItems?: VehicleFeatureItemDto[] | null;
  tags?: TagListDto[] | null;
  files?: FileDto[] | null;
  availability?: VehicleAvailabilityDto | null;
}
